import { CmsLink, CroppedImage, KeyValue } from '../..'

interface cinema {
    nodeId: number
    name: string
    url: string
}

export interface CinemaExperienceSlidesExtension {
    image: CroppedImage
    title: string
    link: CmsLink
    creative: string
    text: string
    promotionName: string
    cinemas: cinema[]
}

export const mapCinemaExperienceSlides = (
    data: any[],
    attributesData: KeyValue[]
): CinemaExperienceSlidesExtension[] => {
    const result = data.map<CinemaExperienceSlidesExtension>(e => e)

    return result
}
